import { useEffect, useState } from 'react';
import { apiErrorHandling } from '../api/apierrorhandling';
import { getNotary } from '../api/stoApi';
import { Notary } from '../models';
import { generalStore } from '../stores/GeneralStore';

export const useNotary = (assetId: string | null, triggerReload: boolean): { notary: Notary | null; loading: boolean } => {
  const [notary, setNotary] = useState<Notary | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    const load = async () => {
      generalStore.setIsLoading(true);
      try {
        if (!assetId) return;
        const response = (await getNotary(assetId)).data;
        const { notary } = response.data;
        notary.possibleDates.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
        notary.possibleDates = notary.possibleDates.filter(({ date }) => new Date(date).getTime() > Date.now());
        setNotary(notary);
      } catch (error: any) {
        if (error?.response?.data?.error === 'NOT_FOUND') return;
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
        setLoading(false);
      }
    };
    if (!assetId) return;
    load();
  }, [assetId, triggerReload]);

  return { notary, loading };
};
